import CityPageTemplate from "../city-template/CityPageTemplate";
import { restonVaConfig } from "./data";

export default function RestonVaPage() {
  return <CityPageTemplate config={restonVaConfig} />;
}